/*eslint-disable*/
import React from "react";
import { Flex, Link, List, ListItem, Text,Center } from "@chakra-ui/react";
import PropTypes from "prop-types";

export default function Footer(props) {
  // const linkTeal = useColorModeValue("teal.400", "red.200");=
  return (
    <Center py={5} paddingRight={{
      lg:"1000px",
      sm: "0px",
      xl: "0px",
    }}
    
    >
      <Text
        color="gray.400"
        textAlign={{
          base: "center",
          xl: "start",
        }}
      >
        &copy; {1900 + new Date().getYear()},{"سامانه مودیان نسخه 1"}
     </Text>
   </Center>
  );
}
